import { render, staticRenderFns } from "./mitraNew.vue?vue&type=template&id=9c69dace"
import script from "./mitraNew.vue?vue&type=script&lang=js"
export * from "./mitraNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports